import { ClickAwayListener as MuiClickAwayListener } from '@mui/material';

export default MuiClickAwayListener;
